const utils = require("./utils");
const extend = Object.assign;
const geocoderService = require("./geocoderservice");

/**
 * @private
 */
class GoogleGeocoderImplementation {
    /**
     *
     * @param parent
     * @param options
     */
    constructor(parent, options) {
        options = options || {};
        this.parent = parent;
        this._geocoder = geocoderService.getGeocoderServiceImplementation();
        this.maxResultsReturn = options.maxResultsReturn || 1;
        this.options = options;
        this.errorCallback = options.errorCallback;

        // Removes maxResultsReturn from options to avoid adding it to the GeocoderQuery.
        this.options.maxResultsReturn = undefined;
        this.options.errorCallback = undefined;
    }

    /**
     *
     * @param query
     */
    geocode(query) {
        const geocoderQuery = extend({ address: query }, this.options);

        this._geocoder.geocode(
            geocoderQuery,
            function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (results.length === 1 || this.maxResultsReturn === 1) {
                        this.parent.set("location", {
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng(),
                            formattedAddress: results[0].formatted_address,
                        });
                    } else {
                        const locationResults = [];
                        for (let i = 0; i < Math.min(results.length, this.maxResultsReturn); i++) {
                            locationResults.push({
                                lat: results[i].geometry.location.lat(),
                                lng: results[i].geometry.location.lng(),
                                formattedAddress: results[i].formatted_address,
                            });
                        }
                        this.parent.set("locationResults", locationResults);
                    }
                } else {
                    if (this.errorCallback) {
                        this.errorCallback(status);
                    } else if (!(typeof console === "undefined" || typeof console.error === "undefined")) {
                        console.error(`Geocode was not successful for the following reason: ${status}`);
                    }
                }
            }.bind(this),
        );
    }
}

/**
 * Returns a geocoder implementation depending on which mapping library is loaded
 * @param parent
 * @param options
 * @private
 */
function getGeocoderImplementation(parent, options) {
    return new GoogleGeocoderImplementation(parent, options);
}

module.exports = {
    getGeocoderImplementation,
};
